import { get } from '@Green-Dot-Corporation/eureka-lib-fetch-utils';

let defaultImages;
let imageOverrides;
let overridePath;
const getFullPath = (resourcePath, override) => {
    if (override && resourcePath && !resourcePath.startsWith('http')) {
        let prefixPath = override;
        let resourcePathMod = resourcePath;

        if (prefixPath.endsWith('/')) {
            prefixPath = prefixPath.slice(0, -1);
        }

        if (resourcePathMod.startsWith('/')) {
            resourcePathMod = resourcePathMod.substring(1);
        }

        return `${prefixPath}/${resourcePathMod}`;
    }

    return resourcePath;
};
export const initializeImages = async ({
    defaultImages: defaultImagesParam,
    overridePath: overridePathParam,
}) => {
    defaultImages = defaultImagesParam;

    if (overridePathParam) {
        try {
            imageOverrides = await get(
                getFullPath('override.json', overridePathParam),
                {
                    credentials: 'same-origin',
                },
            );
            overridePath = overridePathParam;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`NO override detected at  ${overridePathParam}`, e);
        }
    }
};

export const getImagePathForKey = (key) => {
    if (
        imageOverrides &&
        Object.prototype.hasOwnProperty.call(imageOverrides, key)
    ) {
        const imagePath = imageOverrides[key];

        return getFullPath(imagePath, overridePath);
    }

    return (defaultImages ?? {})[key];
};
